export default "__VITE_ASSET__BcVdLAh$__"